import {Component, Input, OnInit} from '@angular/core';
import {Asset} from '../../class/asset';
import {WelfareResultService} from '../../service/welfare-result.service';

@Component({
    selector: 'app-asset-financing',
    templateUrl: './asset-financing.component.html',
    styleUrls: ['./asset-financing.component.css']
})
export class AssetFinancingComponent implements OnInit {

    @Input()
    asset: Asset;

    constructor(private welfareService: WelfareResultService) {
    }

    ngOnInit() {
    }

    deleteAsset() {
        this.welfareService.removeAsset(this.asset);
    }
}
